import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Grid, Autocomplete, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ClearIcon from '@mui/icons-material/Clear';
import { fetchEmployees } from '../../api/employee/employeeApi';
import { fetchDepartments } from '../../api/department/departmentApi';

const statusOptions = [
  { label: 'All', value: '' },
  { label: 'Completed', value: 'Completed' },
  { label: 'In Progress', value: 'In Progress' },
  { label: 'Unknown', value: 'Unknown' },
];

const DepartmentWiseProductionReportFilter = ({ open, onClose, onApply, initialFilters }) => {
  const [filters, setFilters] = useState(initialFilters || {});
  const [departments, setDepartments] = useState([]);
  const [workers, setWorkers] = useState([]);

  useEffect(() => {
    fetchDepartments().then(res => setDepartments(res.data)).catch(() => setDepartments([]));
    fetchEmployees().then(res => setWorkers(res.data)).catch(() => setWorkers([]));
  }, []);

  const handleChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const handleApply = () => {
    onApply(filters);
  };

  const handleReset = () => {
    setFilters({});
    onApply({});
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ m: 0, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h6">Filter Department Wise Production Report</Typography>
        <IconButton aria-label="close" onClick={onClose} sx={{ color: 'grey.500' }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={3} sx={{ mt: 1 }}>
          <Grid item xs={12} md={6} sx={{ minWidth: 220 }}>
            <Autocomplete
              options={departments}
              getOptionLabel={(option) => option.name || option.department_name || 'N/A'}
              value={departments.find(d => d.name === filters.department_name || d.department_name === filters.department_name) || null}
              onChange={(event, newValue) => {
                setFilters({ ...filters, department_name: newValue ? (newValue.name || newValue.department_name) : '' });
              }}
              renderInput={(params) => (
                <TextField {...params} label="Department" variant="outlined" placeholder="Select department..." />
              )}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6} sx={{ minWidth: 220 }}>
            <Autocomplete
              options={workers}
              getOptionLabel={(option) => `${option.emp_code} - ${option.name || option.emp_name || 'N/A'}`}
              value={workers.find(w => w.emp_code === filters.worker_code) || null}
              onChange={(event, newValue) => {
                setFilters({ ...filters, worker_code: newValue ? newValue.emp_code : '' });
              }}
              renderInput={(params) => (
                <TextField {...params} label="Worker" variant="outlined" placeholder="Select worker..." />
              )}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6} sx={{ minWidth: 220 }}>
            <Autocomplete
              options={statusOptions}
              getOptionLabel={(option) => option.label}
              value={statusOptions.find(s => s.value === (filters.production_status || ''))}
              onChange={(event, newValue) => {
                setFilters({ ...filters, production_status: newValue ? newValue.value : '' });
              }}
              renderInput={(params) => (
                <TextField {...params} label="Production Status" variant="outlined" placeholder="Select status..." />
              )}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6} sx={{ minWidth: 220 }}>
            <TextField
              label="From Date"
              name="from_date"
              type="date"
              value={filters.from_date || ''}
              onChange={handleChange}
              fullWidth
              InputLabelProps={{ shrink: true }}
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} md={6} sx={{ minWidth: 220 }}>
            <TextField
              label="To Date"
              name="to_date"
              type="date"
              value={filters.to_date || ''}
              onChange={handleChange}
              fullWidth
              InputLabelProps={{ shrink: true }}
              variant="outlined"
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button variant="outlined" onClick={handleReset} startIcon={<ClearIcon />}>Clear All</Button>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleApply} variant="contained">Apply</Button>
      </DialogActions>
    </Dialog>
  );
};

export default DepartmentWiseProductionReportFilter; 